/**
 * Login.jsx - Office 365 Authentication Page
 */

import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import './Login.css';
import logo from '../assets/lekoil-logo.svg';

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((error) => {
      console.error('Login failed:', error);
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo">
            <div className="logo-icon">
              <img src={logo} alt="Logo" width="50" height="40" />
             </div>
          </div>
          <h1>Technical Dashboard for Asset Performance Monitoring</h1>
          <p className="subtitle">Data-Driven Platform</p>
        </div>

        <div className="login-body">
          {/* <div className="feature-list">
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Target vs Achievable Analysis</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🧠</span>
              <span>Intelligent Dependency Rules</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <span>Real-Time Production Insights</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔗</span>
              <span>Dynamic Entity Management</span>
            </div>
          </div> */}

          <button className="login-button" onClick={handleLogin}>
            <svg className="microsoft-logo" width="21" height="21" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            <span>Sign in with Microsoft</span>
          </button>

          <p className="login-help">
            Use your Office 365 account to access the system
          </p>
        </div>

        <div className="login-footer">
          <p>© 2026 Asset Performance System</p>
          <p className="version">Version 2.0.0</p>
        </div>
      </div>

      <div className="login-background">
        <div className="bg-pattern"></div>
      </div>
    </div>
  );
};

export default Login;